import { appInsightsLogger } from '@/services/(backend)/app-insights-logger';
import { signIn } from 'next-auth/react';

export const authenticateWithMobileToken = async (mobileBearerToken: string): Promise<{ error?: string; success: boolean; }> => {
  const location = 'auth-mobile-service';
  const errorMessage = 'Authentication failed';
  try {
    // use NextAuth's signIn with our custom mobile-token provider
    // we want to sign the user in quietly without a redirect
    const result = await signIn('cinemark-mobile-token', {
      mobileBearerToken,
      redirect: false,
    });


    if (result?.error) {
      appInsightsLogger.logError(result.error, undefined, undefined, location);
      return { error: errorMessage, success: false };
    }

    return { success: true };
  } catch (error) {
    appInsightsLogger.logError(error, undefined, undefined, location);
    return { error: errorMessage, success: false };
  }
};
